import { connect } from 'react-redux'
import { navigationEvent } from 'layers/navigation/store/operations'
import SiteView from './component'

const mapDispatchToProps = {
  navigationEvent,
}

export default connect(null, mapDispatchToProps)(SiteView)
